/**
 * @return {void}
 */
module.exports = function initZoomInfoAutofillFallback() {
    window.document.querySelectorAll('[data-component="whitepaper-form-container"] form').forEach(form => {
        const country = form.querySelector('[name="Country"]');

        if (country instanceof HTMLSelectElement) {
            country.addEventListener("change", () => {
                const hiddenFields = [
                    form.querySelector('[name="FirstName"]'),
                    form.querySelector('[name="LastName"]'),
                    form.querySelector('[name="Title"]'),
                    form.querySelector('[name="Company"]'),
                ];

                hiddenFields.forEach(field => {
                    field.setAttribute("data-hasusertyped", "true");

                    if (field instanceof HTMLElement && !field.value.trim()) {
                        field.parentElement.style.display = '';
                    }
                });
            });
        }

        const zoomInfoFailsafe = () => {
            const visibleZoomInfoFields = ["FirstName", "LastName", "Title", "Company"];

            for (const field of visibleZoomInfoFields) {
                const fieldElement = form.querySelector(`[name="${field}"]`);

                if (fieldElement && !fieldElement.value.trim()) {
                    fieldElement.setAttribute("data-hasusertyped", "true");
                }
            }
        };

        const email = form.querySelector('[name="Email"]');
        if (email) {
            email.addEventListener("blur", zoomInfoFailsafe);
        }

        if (form) {
            form.addEventListener("submit", zoomInfoFailsafe);
        }
    });
}